import script from "./VideoPlayRandom.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlayRandom.vue?vue&type=script&setup=true&lang=js"

import "./VideoPlayRandom.vue?vue&type=style&index=0&id=033e81b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-033e81b7"]])

export default __exports__